// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA7HasNDwslTH2q81yr8gm5kYCQZbVkjSc",
  authDomain: "kosmos-ukko.firebaseapp.com",
  projectId: "kosmos-ukko",
  storageBucket: "kosmos-ukko.firebasestorage.app",
  messagingSenderId: "595561838902",
  appId: "1:595561838902:web:71a1d059c8410314ea5b97"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const firestore = firebase.firestore();

